<template>
    <div class="payment-method-container" :class="{ 'has-payment-methods': paymentInformations.length > 0 }">
        <PaymentMethodIcon
            v-for="paymentInfo in paymentInformationsFilteredDuplicateVouchers"
            :key="paymentInfo.type"
            :paymentInformation="paymentInfo"
        />
    </div>
</template>

<script setup lang="ts">
    import type { IPaymentInformation } from "@/data/model/Customer";
    import { computed } from "vue";

    import PaymentMethodIcon from "@/app/components/payment/PaymentMethodIcon.vue";

    const props = defineProps<{
        paymentInformations: IPaymentInformation[];
    }>();

    const paymentInformationsFilteredDuplicateVouchers = computed(() => {
        const result: IPaymentInformation[] = [];
        let isVoucherAdded = false;
        for (const paymentInformation of props.paymentInformations) {
            if (paymentInformation.type === "Voucher") {
                if (isVoucherAdded) {
                    continue;
                }
                result.push(paymentInformation);
                isVoucherAdded = true;
            } else {
                result.push(paymentInformation);
            }
        }

        return result;
    });
</script>

<style lang="scss">
    .payment-method-container {
        display: flex;

        &.has-payment-methods {
            margin-left: 8px;
        }
    }
</style>
